import { useState } from "react";
import { Plus, Trash2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function SectorsBox() {
  const { session, refresh } = useAuth();
  const t = session.tenant;
  const [sectors, setSectors] = useState(t.settings.production_sectors || []);
  const upd = (i, patch) => setSectors((xs) => xs.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const save = async () => {
    try {
      const clean = sectors.filter((x) => x.name.trim()).map((x) => ({ ...x, name: x.name.trim() }));
      await api.put("/settings", { razao_social: t.razao_social, nome_fantasia: t.nome_fantasia, telefone: t.telefone, endereco: t.endereco, segmento: t.segmento,
        settings: { production_sectors: clean } });
      setSectors(clean);
      await refresh();
      toast.success("Setores salvos");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card-surface p-5 space-y-3" data-testid="settings-sectors">
      <div>
        <p className="font-display text-lg font-semibold">Setores / impressoras de produção</p>
        <p className="text-sm text-muted-foreground">Depois de salvar, cada setor aparece em "Onde cada documento sai" para escolher a impressora dele.</p>
      </div>
      {sectors.map((x, i) => (
        <div key={x.id} className="flex flex-wrap items-center gap-2">
          <Input value={x.name} onChange={(e) => upd(i, { name: e.target.value })} placeholder="Nome do setor (ex.: Cozinha)" className="max-w-xs" data-testid={`sector-name-${i}`} />
          <label className="flex items-center gap-2 text-sm"><Switch checked={!!x.print} onCheckedChange={(v) => upd(i, { print: v })} data-testid={`sector-print-${i}`} />Imprimir pedidos</label>
          <Button size="icon" variant="ghost" onClick={() => setSectors((xs) => xs.filter((_, j) => j !== i))} data-testid={`sector-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" onClick={() => setSectors((xs) => [...xs, { id: `setor-${Date.now().toString(36)}`, name: "", print: false }])} data-testid="add-sector-btn"><Plus className="h-4 w-4 mr-1" />Adicionar setor</Button>
        <Button size="sm" onClick={save} data-testid="sectors-save-btn"><Save className="h-4 w-4 mr-1" />Salvar setores</Button>
      </div>
    </div>
  );
}
